import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { General, GeneralType } from "../../../lib/types";
import { investSkillPoint } from "../../../store/actions";

interface IProps {
  generalId: number;
  specializationName: string;
  qualityOrder: number;
}

const mapStateToProps = (state: any) => ({
  generals: state.governorate.generals
})

const mapDispatchToProps = (dispatch: any) => ({
  investSkillPointDispatch:
    (generalId: number, qualityId: number) => dispatch(investSkillPoint(generalId, qualityId))
})

const connector = connect(mapStateToProps, mapDispatchToProps);

const QualityStepInfo = ({
  generalId,
  specializationName,
  qualityOrder,
  generals,
  investSkillPointDispatch
}: IProps & ConnectedProps<typeof connector>) => {
  const general: General = generals.map((g: GeneralType) => g.general)
    .find((g: General) => g && g.id === generalId);
  const specialization = general.specializations.find(({ name }) => name === specializationName);
  const quality = specialization && specialization.qualities[qualityOrder];
  return (
    quality ? <>
      <h3 className="title">{quality.name}</h3>
      <p className="text-center">
        <strong>Level: {quality.level}/{quality.qualityOrder === 3 ? "1" : "5"}</strong><br/>
        {quality.level > 0 ? quality.nextDescription : quality.enrichedDescription}
      </p>
      {quality.maxLevelReached
        ? <></>
        : <p>
          <a href="#"
             className={`btn btn-black btn-sm ${general.skillPoints === 0 ? "disabled" : ""} ${generalId}`}
             onClick={() => investSkillPointDispatch(generalId, quality.id)}
          >
            Invest 1 point
          </a>
        </p>
      }
    </> : <></>
  )
}

export default connector(QualityStepInfo);
